import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt';
import ReCAPTCHA from "react-google-recaptcha";
import { UseGlobellogin } from './Logincontaxt.jsx/Logincontex';
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';

const Instracter = (()=>{
const {slug} = useParams();
  const [Enable, setEnable] = useState(true);
const {instructer_detail , Getsingleinstructer , single_instructer } = UseGlobelcourse();
const [formMessage, setFormMessage] = useState(''); // State to hold the success message
  const {setsuccessfully} = UseGlobellogin();
function onChange(value) {
  console.log("Captcha value:", value);
  setEnable(false);
}
useEffect(()=>{
  if(slug){
    Getsingleinstructer(slug);
  }
},[slug,instructer_detail]);


 const [bannerData , setBannerImage] = useState([]);
  const [bannerLoading , setBannerLoading] = useState(true);

  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        setBannerLoading(true);
        const response = await fetch(`${BASE_URL}/banner/?page=instructerDetail`);
        const result = await response.json();
        setBannerImage(result.data[0]);
            } catch (error) {
              console.error('Error fetching banner:', error);
            } finally {
              setBannerLoading(false);
            }
          };
          
          fetchBannerImage();
        }, []);

 const [data, setData] = useState({
    name:"",
    email:"",
    mobile_number:"",
    message:"",
  });

  const handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({
      ...data,
      [name]: value
    });
  };

  const submitForm = async () => {
    const formData = {
      name: data.name,
      email: data.email,
      mobile_number: data.mobile_number,
      message: data.message,
    };
  
    try {
      const response = await fetch(`${BASE_URL}/contactform/`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
      if (response.ok) {
        setsuccessfully(result.message);
        // setTimeout(() => setsuccessfully(""), 10000);
        setData({
          name: '',
          email: '',
          mobile_number: '',
          message: '',
        });
      } else {
        setFormMessage(result.message);
      }
    } catch (error) {
      console.error('Error:', error);
      setFormMessage('Error submitting the form');
    }
  console.log(data);
  
  };


  

  return (
    <>
   {
      bannerLoading && bannerData && bannerData?.image ? (
        <SubLoading/>
      ):(
   <div className="breadcumb-wrapper"

style={{
       backgroundImage: `url(${BASE_URL}${bannerData?.image})`,
       backgroundSize: 'contain',
       backgroundPosition: 'center',
       height:"50px"
     }} 
     data-overlay="title" data-opacity={8}>
  <div className="breadcumb-shape" data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Instructor Details</h1>
      <ul className="breadcumb-menu">
        <li><a href="index.html">Home</a></li>
        <li>Instructor Details</li>
      </ul>
    </div>
  </div>
</div>
      )}



<section className="space">
  {
    single_instructer.map((curinstructer , index)=>(
  <div className="container" key={index}> 
    <div className="team-details-about-info" >
      <div className="row gx-40">
        <div className="col-lg-6 position-relative">
          <div className="team-details-thumb">
            <img src={`${BASE_URL}${curinstructer?.CourseInstructor_image}`} alt="team image" />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="about-box">
            <div className="about-info">
              <h2 className="title">{curinstructer?.CourseInstructor_name}</h2>
              {/* <p className="desig">A certified instructor from Edura</p> */}
            </div>
            <div className="th-social style2">
              <a target="_blank" href={curinstructer?.CourseInstructor_facebook_url}><i className="fab fa-facebook-f" /></a>
              <a target="_blank" href={curinstructer?.CourseInstructor_twitter_url}><i className="fab fa-twitter" /></a>
              <a target="_blank" href={curinstructer?.CourseInstructor_instgrame_url}><i className="fab fa-instagram" /></a>
              <a target="_blank" href={curinstructer?.CourseInstructor_linkedin_url}><i className="fab fa-linkedin-in" /></a>
            </div>
          </div>
          <p>{curinstructer.CourseInstructor_shortbio}</p>
          
          <div className="about-quality">
            <div className="quality-box">
              <span className="quality-text">Course: 4</span>
              <span className="quality-text">Students: 50</span>
            </div>
            <div className="quality-box">
              <span className="quality-text">Reviews:</span>
              <div className="course-rating">
                    <div
                   className="star-rating"
                   role="img"
                   aria-label={`Rated ${curinstructer?.CourseInstructor_rating} out of 5`}
                   >
                  <span style={{ width: `${(curinstructer?.CourseInstructor_rating / 5) * 100}%`, }}>
                  Rated <strong className="rating">{curinstructer?.CourseInstructor_rating}</strong> out of 5
                  </span>
                  </div>
                ({curinstructer.CourseInstructor_rating})
                </div>

            </div>
            <div className="quality-box">
              <span className="quality-text">Experiance:</span>
              <span className="quality-text">{curinstructer?.CourseInstructor_Experience}</span>
            </div>
          </div>
          <div className="about-contact-wrap">
            <div className="about-contact">
              <div className="about-contact-icon">
                <i className="fas fa-phone" />
              </div>
              <div className="about-contact-details">
                <span className="about-contact-subtitle">Call Any Time:</span>
                <h6 className="about-contact-title">{curinstructer?.CourseInstructor_mobile_no}</h6>
              </div>
            </div>
            <div className="about-contact">
              <div className="about-contact-icon">
                <i className="fas fa-envelope" />
              </div>
              <div className="about-contact-details">
                <span className="about-contact-subtitle">Mail Any Time:</span>
                <h6 className="about-contact-title">{curinstructer?.CourseInstructor_email}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      

    <div className="space-top">
      <div className="row">

        <div className="col-lg-8">

          <h3 className="title h4 fw-semibold mt-n1">Biography</h3>
          <p dangerouslySetInnerHTML= {{__html : curinstructer.Biography}} ></p>

          {/* <div dangerouslySetInnerHTML= {{__html : curinstructer.Education_Qualification}} ></div> */}
         
        </div>


      

        <div className="col-lg-4">    
         <form className="th-team-form bg-smoke ajax-contact mt-50 mt-lg-0"  >
            <div className="form-title mb-30 text-center">
              <h3 className="fw-semibold mt-n1">Quick Contact</h3>
              <p>Feel free to contact us through Twitter or Facebook if you prefer!</p>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">

                  <input type="text"
                   placeholder="Your Name" 
                   name ='name'
                   value={data.name}
                   onChange={handleInput}
                   required
                   className="form-control style-white" />
                  <i className="fal fa-user" />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <input type="mail"
                  name='email'
                   placeholder="Your Email"
                   value={data.email}
                   onChange={handleInput}
                   required
                    className="form-control style-white" />
                  <i className="fal fa-envelope" />

                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <input type="text" 
                  placeholder="mobile_number"
                  name='mobile_number'
                  required
                  value={data.mobile_number}
                  onChange={handleInput}
                   className="form-control style-white" />
                  <i className="fal fa-phone-flip" />

                </div>
              </div>

              <div className="col-12">
                <div className="form-group">     
                  <textarea
                  
                   placeholder="Write Message..."
                  className="form-control style-white"
                  name='message'
                  required
                  value={data.message}
                  onChange={handleInput}
                   />
                  <i className="fal fa-pencil" />
                </div>
              </div>
             {formMessage && <div className="form-message" style={{marginBottom:"15px", fontSize:"1.2rem",textAlign:"center",padding: "15px",color:"green"}}>{formMessage}</div>}

             <ReCAPTCHA
             sitekey="6LfZHGUrAAAAALvAACRghdiTSXqT6Fm25bjeEQ2L"
             onChange={onChange} style={{margin:"15px"}}
                />
              <div className="col-12">
                <button className="th-btn w-100"  disabled={Enable} style={Enable ?{opacity:'0.6'}:{opacity:''}} onSubmit={submitForm}>Send Massage<i className="fas fa-arrow-right ms-2" /></button>
              </div>
            </div>
          </form>
        </div>


      </div>
    </div>
  </div>
    ))}

</section>

    
    </>
  )
});

export default Instracter
